import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { LoginSenceForm } from './LoginSence/LoginSenceForm'

interface LogoutSenceSuccessProps {
  onHide: () => void
}

export const LogoutSenceSuccess = ({ onHide }: LogoutSenceSuccessProps) => {
  const t = useTranslationRankmi({
    prefix: 'courses.show.sence.logoutSuccess',
  })

  return (
    <Modal size="lg" show centered onHide={() => onHide()}>
      <Modal.Header closeButton className="ml-3 mr-3 mt-2 pb-2">
        <Modal.Title>
          <FontAwesomeIcon icon={faExclamationCircle} className="red mr-2" />
          {t('title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="ml-3 mr-3">
        <p>{t('message')}</p>
        <div className="d-flex justify-content-center">
          <LoginSenceForm />
        </div>
      </Modal.Body>
    </Modal>
  )
}
